<template>
  <div>
    <v-card>
      <v-card-title class="primary white--text title">
        Charge Exclusions
      </v-card-title>
      <v-row no-gutters class="pt-4">
        <v-col class="text-left px-4">
          <v-btn class="primary" @click="addRow()">Create New Exclusion</v-btn>
        </v-col>
      </v-row>
      <v-card-text>
        <ag-grid-vue
          style="height: 500px"
          class="ag-theme-alpine mt-3 grid"
          :columnDefs="columnDefs"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          pagination
          :paginationPageSize="10"
          :frameworkComponents="frameworkComponents"
          :editType="'fullRow'"
          :rowSelection="'single'"
          :suppressClickEdit="true"
          @grid-ready="resizeGrid"
          @rowDataChanged="resizeGrid"
          @pagination-changed="resizeGrid"
        ></ag-grid-vue>
      </v-card-text>
      <v-card-actions class="px-4 pb-5">
        <v-spacer></v-spacer>
        <v-btn @click="onClose()">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      :color="success ? 'green' : 'red'"
      :timeout="2000"
    >
      {{ snackbarMsg }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { HTTP } from "@/http-common";
import { AgGridVue } from "ag-grid-vue";
import TableActions from "@/components/table-actions";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { ChargeExclusion } from "@/models/ChargeExclusion";

export default {
  name: "ChargeExclusions",
  components: {
    AgGridVue,
  },
  data() {
    return {
      gridOptions: null,
      columnDefs: null,
      rowData: null,
      defaultColDef: null,
      frameworkComponents: null,
      dialog: false,
      selectedRows: null,
      snackbar: false,
      success: false,
      snackbarMsg: "",
    };
  },
  methods: {
    onClose() {
      let vm = this;
      vm.$emit("onClose", {});
    },
    getSelectedRows(params) {
      let vm = this;
      vm.selectedRows = params.api.getSelectedRows();
    },
    getChargeExclusion() {
      return new Promise((resolve, reject) => {
        let response = HTTP.get("BulkUpload/getChargeExclusions");
        response
          .then((data) => {
            this.rowData = [...data.data];
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    addRow() {
      let vm = this;
      vm.rowData.push({ id: 0, ubCustNo: null, description: null });
      vm.$nextTick(() => {
        let index = vm.rowData.length - 1;
        vm.gridOptions.api.setFocusedCell(index, "ubCustNo");
        vm.gridOptions.api.startEditingCell({
          rowIndex: index,
          colKey: "ubCustNo",
        });
      });
    },
    resizeGrid(grid) {
      let vm = this;
      vm.gridOptions = grid;
      grid.api.sizeColumnsToFit();
    },
    save(data) {
      let vm = this;
      return new Promise((resolve, reject) => {
        let response = HTTP.post("BulkUpload/upsertChargeExclusion", data);
        response
          .then((data) => {
            if (data.status == 200) {
              vm.snackbar = true;
              vm.success = true;
              vm.snackbarMsg = "Saved";
              vm.getChargeExclusion();
            } else {
              vm.snackbar = true;
              vm.success = false;
              vm.snackbarMsg = "Failed Saving";
            }
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteItem(data) {
      let vm = this;
      this.$dialog
        .confirm("Are you sure you want to delete Charge Exclusion?")
        .then(async () => {
          return new Promise((resolve, reject) => {
            let response = HTTP.post(
              `BulkUpload/deleteChargeExclusions/${data}`
            );
            response
              .then((data) => {
                if (data.status == 200) {
                  vm.snackbar = true;
                  vm.success = true;
                  vm.snackbarMsg = "Deleted Successfully";
                  vm.getChargeExclusion();
                } else {
                  vm.snackbar = true;
                  vm.success = false;
                  vm.snackbarMsg = "Deletion Failed";
                }
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          });
        })
        .catch(() => {});
    },
    onEdit(data) {
      let vm = this;
      vm.gridOptions.api.forEachNode((rowNode, index) => {
        if (rowNode.data.ubCustNo == data.ubCustNo) {
          vm.gridOptions.api.setFocusedCell(index, "ubCustNo");
          vm.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: "ubCustNo",
          });
        }
      });
    },
  },
  mounted() {
    let vm = this;
    vm.getChargeExclusion();
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "UB Customer No",
        field: "ubCustNo",
        sortable: true,
        maxWidth: 200,
      },
      {
        headerName: "Description",
        field: "description",
        sortable: true,
      },
      {
        headerName: "Actions",
        field: "action",
        maxWidth: 120,
        cellRenderer: "tableActions",
        cellRendererParams: {
          clicked: function (param) {
            switch (param.type) {
              case "save":
                vm.gridOptions.api.stopEditing();
                vm.save(param);
                break;
              case "edit":
                vm.onEdit(param);
                // vm.save(param);
                break;
              case "delete":
                vm.deleteItem(param.id);
                break;
            }
          },
        },
        editable: false,
      },
    ];

    vm.defaultColDef = {
      flex: 1,
      minWidth: 100,
      editable: true,
    };

    vm.frameworkComponents = {
      tableActions: TableActions,
    };
  },
};
</script>
<style scoped>
.grid {
  text-align: left !important;
}
</style>